import { useMemo } from 'react';
import { SECTION_NAMES } from '@repo/common';
import { getIsHotColdSection } from 'features/hotCold';
import type ISectionSettings from 'types/models/ISectionSettings';

export const useBackgroundSourceName = (data: ISectionSettings, isColdSelected: boolean) => {
  const isHotColdSection = getIsHotColdSection(data);
  return useMemo(() => {
    if (!isHotColdSection) {
      return data.name;
    }

    return isColdSelected ? SECTION_NAMES.COLD_GAMES : SECTION_NAMES.HOT_GAMES;
  }, [data.name, isColdSelected, isHotColdSection]);
};
